var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ededed;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d{fill:#0b6946;}.e{fill:#fff;}.f{fill:#d00a1e;}.g{fill:#ffd250;}.h{fill:#00c3a0;}.i{fill:#00aadc;}.j{fill:#732d37;}.k{fill:#aad264;}.l{fill:#874150;}.m{fill:#783c46;}.n{fill:#ffe15a;}.o{fill:#ffb478;}.p{fill:#9b4b5a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 22,
    transform: "translate(53 401)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 16,
    rx: 4,
    transform: "translate(53 404)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-53 -401)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1.8,88.273A1.813,1.813,0,0,0,0,90.1v12.342a1.813,1.813,0,0,0,1.8,1.829H8v-16Z",
    transform: "translate(0 -88.273)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 8,
    height: 16,
    transform: "translate(8 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M347.536,88.273h-6.2v16h6.2a1.813,1.813,0,0,0,1.8-1.829V90.1A1.813,1.813,0,0,0,347.536,88.273Z",
    transform: "translate(-325.333 -88.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M256.714,263.893l-.714.363v.363h.357Z",
    transform: "translate(-244 -255.517)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.037 8.195)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M252.371,276.4a.18.18,0,0,1-.178-.182v-.726a.178.178,0,1,1,.357,0v.726A.18.18,0,0,1,252.371,276.4Z",
    transform: "translate(-250.409 -274.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M216.094,261.18a2.771,2.771,0,0,1-1.906-.775.184.184,0,0,1-.009-.256.177.177,0,0,1,.252-.009,2.379,2.379,0,0,0,3.326,0,.176.176,0,0,1,.252.009.184.184,0,0,1-.009.256A2.771,2.771,0,0,1,216.094,261.18Z",
    transform: "translate(-214.131 -260.09)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M229.945,284.257a2.281,2.281,0,0,1-1.281-.393l.2-.3a1.962,1.962,0,0,0,2.168,0l.2.3A2.28,2.28,0,0,1,229.945,284.257Z",
    transform: "translate(-217.945 -274.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M240.6,246.764l-.394.62-.067.2,1.026-.242Z",
    transform: "translate(-228.883 -239.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M208.549,212.626c-.472,0-1.038-.4-1.188-1.3l.352-.061c.125.748.577,1,.849,1,.083,0,.17-.032.177-.092s.01-.089-.177-.153a.642.642,0,0,1-.3-.168c-.326-.379.116-.781.328-.973.037-.034.053-.063.049-.074a.19.19,0,0,0-.161-.078.437.437,0,0,1-.449-.34.488.488,0,0,1,.233-.544l.164.323a.128.128,0,0,0-.05.135c0,.019.015.063.1.063a.531.531,0,0,1,.494.312.42.42,0,0,1-.145.474c-.234.213-.375.373-.3.463a.5.5,0,0,0,.143.063c.161.055.46.158.417.538a.5.5,0,0,1-.522.413Z",
    transform: "translate(-197.641 -204.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M256.357,203.842a.8.8,0,0,0-.357-1.089s2.5-.363,2.141,2.9h0a2.8,2.8,0,0,1-.706-.817l-1.078-.635v-.363Z",
    transform: "translate(-244 -197.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M256,241.055l1.784,1.089-.714.363L256,241.418Z",
    transform: "translate(-244 -233.768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M240.775,210.969h0a.36.36,0,0,1,.357.363h0a.721.721,0,0,0-.131.822l.081.164a.712.712,0,0,0,.131.185l.99,1.008v-.5a4.085,4.085,0,0,0-.418-1.8h0a1.069,1.069,0,0,0-.958-.6h-.052v.363Z",
    transform: "translate(-229.489 -204.771)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M233.519,210.6l-.357.363v.363s.425-.219.568-.289a.133.133,0,0,0,.024-.22C233.709,210.779,233.519,210.6,233.519,210.6Z",
    transform: "translate(-222.232 -204.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M194.325,251.754a3.064,3.064,0,0,1-3.033-3.086h.357a2.677,2.677,0,1,0,5.353,0h.357A3.064,3.064,0,0,1,194.325,251.754Z",
    transform: "translate(-182.325 -241.018)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.101 8.481)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "n",
    cx: 0.242,
    cy: 0.246,
    rx: 0.242,
    ry: 0.246
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "n",
    cx: 0.242,
    cy: 0.246,
    rx: 0.242,
    ry: 0.246,
    transform: "translate(0.535 0.87)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "n",
    cx: 0.242,
    cy: 0.246,
    rx: 0.242,
    ry: 0.246,
    transform: "translate(1.405 1.528)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "n",
    cx: 0.242,
    cy: 0.246,
    rx: 0.242,
    ry: 0.246,
    transform: "translate(5.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "n",
    cx: 0.242,
    cy: 0.246,
    rx: 0.242,
    ry: 0.246,
    transform: "translate(4.804 0.87)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "n",
    cx: 0.242,
    cy: 0.246,
    rx: 0.242,
    ry: 0.246,
    transform: "translate(3.934 1.528)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M245.294,287.457h-.357a.36.36,0,0,1-.357-.363h0a.36.36,0,0,1,.357-.363h.357a.36.36,0,0,1,.357.363h0A.36.36,0,0,1,245.294,287.457Z",
    transform: "translate(-233.115 -277.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M257.435,204.84a1.325,1.325,0,0,0,.706.817h0c.357-3.268-2.141-2.9-2.141-2.9C257.784,202.752,257.435,204.84,257.435,204.84Z",
    transform: "translate(-244 -197.281)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsFlag);
export default __webpack_public_path__ + "static/media/es-flag.c4298f47e9e081481bfb747a14ab1eac.svg";
export { ForwardRef as ReactComponent };